import { render, staticRenderFns } from "./quoteList.vue?vue&type=template&id=1f305536&scoped=true&"
import script from "./quoteList.vue?vue&type=script&lang=js&"
export * from "./quoteList.vue?vue&type=script&lang=js&"
import style0 from "./quoteList.vue?vue&type=style&index=0&id=1f305536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f305536",
  null
  
)

export default component.exports